import React, {useContext, useEffect, useState} from 'react'
import SearchResultsContainer from './components/VehicleSearch/SearchResultsContainer'
import {translateService} from './services/TranslateService';
import moment from 'moment-timezone';
import './locales/index';
import './App.scss';
import {GlobalStore} from './reduxStore';
import {useDispatch, useSelector} from 'react-redux';
import LoginContainer from './components/Login/LoginContainer';
import ApiServiceFactory from './services/api/ApiServiceFactory';
import BusyModal from './components/BusyModal/BusyModal';
import ResponseModal from './components/ResponseModal/ResponseModal';
import Modal from 'react-modal';
import {handleUrlWithHashtag} from './GetUrlParams';
import {MakeReservation} from './components/MakeReservation/MakeReservation';
import {DataContext} from './contexts/dataContext';
import {nextWorkingDay} from "./components/MakeReservation/util";
import axios from "axios";
import {Dialog} from "@mui/material";
import {Card} from "react-bootstrap";
import Translate from "react-translate-component";
import {GetCustomerBehaviourParams} from "./services/CustomerBehaviourData";
import GoogleMap from "./components/Map/googleMaps";

// styling for react-modal
const customStyles = {
    content: {
        width: 'auto',
        minWidth: '200px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

declare var google: any;

const App = (props: any) => {
    const {shortcodeLang, shortcodeCity, shortcodeMap} = props;
    const search = handleUrlWithHashtag();
    const lang = shortcodeLang === undefined ? (new URLSearchParams(search).get('lang')) || "fi" : (shortcodeLang === "en" ? "en" : "fi");
    const {v3ApiUrl, appContext, changeSearchParameters, searchParameters, route, page, changeRoute, changeResType, enableOneWay,
        sendGaEvent, changeCustomerBehaviourData, changeAcrissCodeFromUrl, changeModelId } = useContext(DataContext);
    const dispatch = useDispatch();
    const responseModal = useSelector((state: GlobalStore) => state.chauffeurReducer.responseModal);
    const apiMessage = useSelector((state: GlobalStore) => state.chauffeurReducer.apiMessage);
    const token = useSelector((state: GlobalStore) => state.chauffeurReducer.dbToken);
    const jwt = useSelector((state: GlobalStore) => state.chauffeurReducer.jwt);
    const API_URL = useSelector((state: GlobalStore) => state.chauffeurReducer.API_URL);
    let storeDiscountCoupon = useSelector((state: GlobalStore) => state.chauffeurReducer.coupon);
    const [showLogin, setShowLogin] = useState(false);
    const [showFullScreenMap, setShowFullScreenMap] = useState<boolean>(false);
    const dataContext = useContext(DataContext);
    const { version } = require('../package.json');
    const copyrightYear = moment().get('year');
    let startDate = new URLSearchParams(search).get("startdate") ? moment(new URLSearchParams(search).get("startdate"), "DD.MM.YYYY HH:mm") : null
    let endDate = new URLSearchParams(search).get("enddate") ? moment(new URLSearchParams(search).get("enddate"), "DD.MM.YYYY HH:mm") : null
    let discount = new URLSearchParams(search).get("vip") ?? new URLSearchParams(search).get("code"); // vip takes priority over normal discount code
    let carId = !(sessionStorage.getItem('carIdChanged') ?? undefined) ? new URLSearchParams(search).get("carid") : null;
    let acriss = new URLSearchParams(search).get("acriss")
    let day = new URLSearchParams(search).get("days")
    let city = shortcodeCity === undefined ? (new URLSearchParams(search).get("city")) || "" : shortcodeCity;
    let modelId = new URLSearchParams(search).get("modelid");
    let mapEnableUrl = shortcodeMap === undefined ? (new URLSearchParams(search).get("map")) || "true" : shortcodeMap;
    let urlCodeSavedData = sessionStorage.getItem('urlCodeValid') ?? undefined;
    const defaultDate = nextWorkingDay().hour(8).minute(60);
    const [latlng, setLatlng] = useState<number[]>([
        60.167488, // default lat
        24.942747,// default lng
        0 // 0 = normal res, 1 = oneway coords
    ]);
    const customerId = new URLSearchParams(search).get("id")
    const authHash= new URLSearchParams(search).get("hash")
    const customerBehaviourData = GetCustomerBehaviourParams();

    const hideWpContent = (id: string) => {
        let contentId = document.getElementById(id);
        if (contentId) {
            contentId.style.display = 'none'
        }
    }

    const showWpContent = (id: string) => {
        let contentId = document.getElementById(id);
        if (contentId) {
            contentId.style.display = 'block'
        }
    }

    useEffect(() => {
        const apiVersion = 'v3';
        dispatch({type: 'SET_API_VERSION', payload: apiVersion})
        dispatch({type: 'SET_API_URL', payload: v3ApiUrl})
        const apiService = ApiServiceFactory(
            token || "",
            jwt || "",
            apiVersion,
            v3ApiUrl,
            appContext ?? "",
        );
        // Checking for production environment
        if(appContext !== "production") {
            console.log('Development environment ', apiVersion, v3ApiUrl);
        }
        dispatch({type: 'SET_API_SERVICE', payload: apiService});

        // check if url discount code is valid
        if (dataContext.reservationCreated || (!discount && !searchParameters?.discount)) return;

        if (discount && urlCodeSavedData) {
            // check if code was manually removed and do not reload it
            if (urlCodeSavedData === 'removed') return;
        }

        let codeToCheck = searchParameters?.discount ?? discount ?? '';
        if (codeToCheck === '') return; // if empty, return - no such URL exists
        apiService?.vehicle.getCoupon(codeToCheck)
            .then(r => {
                if (!r.valid) {
                    dispatch({ type: "SET_DISCOUNT_COUPON", payload: null });
                    sessionStorage.removeItem("coupon");
                    sessionStorage.setItem('urlCodeValid', 'false');
                }
                else {
                    sessionStorage.setItem('urlCodeValid', 'true');
                    sessionStorage.setItem('coupon', JSON.stringify({ ...r, code: codeToCheck }));
                    dispatch({ type: "SET_DISCOUNT_COUPON", payload: { ...r, code: codeToCheck } });
                }})
            .catch(e => {
                console.log('coupon fail ' + e);
                dispatch({ type: "SET_DISCOUNT_COUPON", payload: null });
                sessionStorage.setItem('urlCodeValid', 'false');
                sessionStorage.removeItem("coupon");
            })
    }, [token, jwt, dispatch, search]);

    useEffect(() => {
        if(dataContext.page === 0){
            dataContext.changeVehicle(null);
        }
    }, [dataContext.page]);

    const urlLogin = async () => {
        try{
            if(!customerId || !authHash){} // if no id or hash, do nothing
            let data = JSON.stringify(
                {
                    "customerId": parseInt(customerId!),
                    "authenticationHash": authHash?.toString()
                }
            );

            const res = await axios.post(`${v3ApiUrl}/login/try-authentication-hash`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                if(res.data?.data) {
                    const jwt: string = res.data?.data.jwt;
                    const token: string = res.data?.data.token.toString()
                    if(token && jwt){
                        dispatch({type: 'SET_TOKEN', payload: {jwt, token}}); // token must be set before user is data is set
                        const customer = await axios.get(`${v3ApiUrl}/customers/me`,{
                            headers: {
                                Authorization: `Bearer ${jwt}`,
                                'X-Auth-Token': `${token}`
                            }
                        })
                        let birthdateValid = (customer.data.data.birthDate);
                        let countryValid = (customer.data.data.country !== null && customer.data.data.personalIdCodeRecorded);
                        if (birthdateValid && countryValid && customer.data.data.givenName !== '' && customer.data.data.familyName !== '' &&
                            customer.data.data.address !== '' && customer.data.data.postalCode !== '' && customer.data.data.municipality !== '' &&
                            customer.data.data.phoneNumber !== '' && customer.data.data.email !== '') {
                            dataContext.changeUser({...customer.data.data, smsLogin: true});
                            dataContext.changeCustomer({...customer.data.data, smsLogin: true});
                            if(authHash){
                                dataContext.changeLoggedIn(true, authHash);
                            }
                        } else {
                            dataContext.changeUser({...customer.data.data, birthDate: undefined, smsLogin: false});
                            dataContext.changeCustomer({...customer.data.data, birthDate: undefined, smsLogin: false});
                            if(authHash){
                                dataContext.changeLoggedIn(false, authHash);
                            }
                        }

                        if ((window as any).ap3c && customer.data.data.email){
                            // add customer when we know the email and if ap3c func exists
                            console.log('Ortto Tracking on');
                            (window as any).ap3c.track({"v":0 ,"email": customer.data.data.email});
                        }
                    }
                }
        } catch (e) {
            console.log(e)
        }
    }
    // change jwt  data
    useEffect(() => {
        if(customerId && authHash){
            urlLogin()
        }
        if(dataContext.customer?.loggedIn && carId){
            if(carId === dataContext.vehicle?.id.toString()) {
                if(dataContext.vehicle.availabilityData?.available){
                    dataContext.changeRoute("/makereservation")
                } else{
                    if(appContext !== "production") {
                        console.log('vehicle not available')
                    }
                    dataContext.changePage(0)
                    dataContext.changeRoute("/")
                }
            }
        }

    }, [customerId, authHash, carId]);

    document.getElementsByClassName('mapboxgl-map')[0]?.setAttribute('style', 'height: 100vh')

    useEffect(() => {
        if (lang && lang === 'en') {
            dispatch({type: 'SET_LANG', payload: lang})
            translateService.setLocale(lang);
            dataContext.changeLanguage(lang);
        } else { // 'fi' or any incorrect url param or lang setting
            dispatch({type: 'SET_LANG', payload: 'fi'})
            translateService.setLocale('fi');
            dataContext.changeLanguage('fi');
        }
        if(lang) {
            dataContext.changeUser({...dataContext.user, language: lang === 'en' ? 'en' : 'fi'});
        }
    }, [dispatch, lang])

    useEffect(() => {
        changeRoute(sessionStorage.getItem("route"));
        if(mapEnableUrl === "true"){
            dataContext.changeMapEnable(true)
        } else if(mapEnableUrl === "false"){
            dataContext.changeMapEnable(false)
        }

        if (startDate && startDate.isSame(moment(), 'day') && !startDate.minute()) {
            startDate = moment().add(15, "minutes")
        }
        if (!startDate && !endDate) {
            startDate = searchParameters?.startDate ? moment(searchParameters?.startDate).clone() : defaultDate.clone()
            endDate = searchParameters?.endDate ? moment(searchParameters?.endDate).clone() : defaultDate.clone().add(2, "hours")
        } else if (!endDate && startDate && !day) {
            endDate = startDate.clone().add(2, "hours")
        } else if (!startDate && endDate && !day) {
            startDate = endDate.clone().subtract(2, "hours")
        }
        if (day && startDate) {
            let dayIncrease = parseInt(day!)
            endDate = startDate.clone().add(dayIncrease, "days")
        } else if (day) {
            let dayIncrease = parseInt(day!)
            startDate = moment().add(2, "hours")
            endDate = moment().add(dayIncrease, "days")
        }

        const defaultChangeSearchParameters = (altLat?: number, altLon?: number, altLocation?: any) => {
            changeSearchParameters({
                ...searchParameters,
                startDate: searchParameters?.startDate ?? startDate,
                endDate: searchParameters?.endDate ?? endDate,
                startTime: searchParameters?.startTime ?? (startDate?.clone().format("HH:mm")),
                endTime: searchParameters?.endTime ?? (endDate?.clone().format("HH:mm")),
                discount: searchParameters?.discount ?? (discount! && urlCodeSavedData !== "removed" ? discount : undefined),
                lon: altLon ?? (searchParameters?.lon || latlng[1]),
                lat: altLat ?? (searchParameters?.lat || latlng[0]),
                carId: carId ? parseInt(carId) : null,
                distance: 30000,
                showStart: 0,
                km: 100,
                showAmount: 10,
                vehicleType: acriss ? acriss : searchParameters?.vehicleType,
                location: altLocation ?? (((carId && !searchParameters?.location)
                || (Number(modelId) && (!city && !searchParameters?.location) ) ?
                    (latlng[2] === 0 ? "Helsinki" : latlng) // if default lat+lon in a2a mode --> "Helsinki" shows in search bar
                    : searchParameters?.location)),
                // note: searchParameters.location can have 2 types: on startup + location to search  --> 'string', else 'object' (used in vehicle search component)
            })

            if (acriss) { // will not use acriss if user changed filter types or reset filter in session
                let filteredChanged = sessionStorage.getItem('filterChange') ?? undefined;
                if (filteredChanged === '1') {
                    return; // does not reoad apply if filter was changed by user before reload
                }
                changeAcrissCodeFromUrl(acriss);
            } else if (modelId) {
                changeModelId(Number(modelId))

            }
        }

        let geocodeLocation, geocodeLat, geocodeLng;
        if (city && (!searchParameters?.lat || !searchParameters.lon)) { // url city only used once, if new search done - new city takes priority
            // Here is the documentation: https://developers.google.com/maps/documentation/javascript/geocoding#ReverseGeocoding
            const geocoder = new google.maps.Geocoder(); // Create a new instance of google.maps.Geocoder
            geocoder.geocode({ address: city }, (results: any, status: string) => {
                if (status === 'OK') {
                    sessionStorage.setItem('locationFromUrl', '1'); // used to not auto open time & date picker popups after using url city for search
                    const { lat, lng } = results[0].geometry.location;
                    geocodeLocation = results[0].address_components[0].long_name;
                    geocodeLat = lat();
                    geocodeLng = lng();
                    defaultChangeSearchParameters(geocodeLat, geocodeLng, geocodeLocation);
                } else { // fallback to normal scenario without url city
                    console.log('Geocode was not successful for the following reason: ' + status);
                    defaultChangeSearchParameters();
                }
            });
        } else if ((discount && !searchParameters?.location && !searchParameters?.discount)
            || (acriss && !searchParameters?.location && !searchParameters?.vehicleType)) {
            defaultChangeSearchParameters(latlng[0], latlng[1], "Helsinki");
        }
        else {
            defaultChangeSearchParameters();
        }
    }, []);

    useEffect(() => {
        let apiVersion = 'v3';
        dispatch({type: 'SET_API_VERSION', payload: apiVersion})
        dispatch({type: 'SET_API_URL', payload: v3ApiUrl})
        const apiService = ApiServiceFactory(
            token || "",
            jwt || "",
            apiVersion,
            v3ApiUrl,
            appContext || ""
        );
        dispatch({type: 'SET_API_SERVICE', payload: apiService})

    }, [token, jwt, dispatch, search]);

    useEffect(() => {
        // will only active when moving between search and make reservation + if car id present in url on start
        if (route === '/makereservation' && dataContext.vehicle?.id) {
            // hide all other WordPress content if vehicle has been selected
            hideWpContent("wpcontent2");
            hideWpContent("wpcontent3");
            hideWpContent("wpcontent4");
            hideWpContent("wpcontent5");
            hideWpContent("wpcontent6");
            hideWpContent("wpcontent7");
            hideWpContent("wpcontent8");
            hideWpContent("wpcontent9");
        } else {
            // show all other WordPress content if search page
            showWpContent("wpcontent2");
            showWpContent("wpcontent3");
            showWpContent("wpcontent4");
            showWpContent("wpcontent5");
            showWpContent("wpcontent6");
            showWpContent("wpcontent7");
            showWpContent("wpcontent8");
            showWpContent("wpcontent9");
        }

        if(route === '/' && !searchParameters?.startDate && !searchParameters?.endDate) {
            // case: returning to search page after successful res - to ensure...
            // date pickers get set to correct next working day date
            let resetDateTimeValues = sessionStorage.getItem("resetDateTimes") ?? undefined;
            if(!resetDateTimeValues) return; // check so the following does not run on normal app startup

            const resetDates = nextWorkingDay().hour(8).minute(60); // avoid using 'defaultDates'...
            // from initial variables in cases where session kept open for too long
            sessionStorage.removeItem("resetDateTimes");
            changeSearchParameters({...searchParameters, startDate: resetDates.clone(),
                endDate: resetDates.clone().add(2, "hours")});
        }
    }, [route, dataContext.vehicle])

    const button = document.querySelector('.menu-item-7453');
    const mapBtn = document.getElementById('mapLoginBtn')
    if(mapBtn){
        mapBtn.addEventListener('click', (event) => {
            if (window.location.pathname === '/') {
                event.preventDefault();
            }
            setShowLogin(true);
        });
    }
    if (button) {
        button.addEventListener('click', (event) => {
            if (window.location.pathname === '/') {
                event.preventDefault();
            }
            setShowLogin(true);
        });
    }

    useEffect(() => {
        // oneway url params
        if (enableOneWay) { // if enabled in app build
            let oneway = new URLSearchParams(search).get("oneway");
            if(oneway !== null) {
                // oneway param value can be anything, but if exists in url, oneway must be set true
                changeResType(true);}
        }
    }, [enableOneWay])

    useEffect(() => {
        changeRoute(sessionStorage.getItem("route"));
        changeCustomerBehaviourData(customerBehaviourData);
    }, []);

    // This will run one time after the component mounts
    useEffect(() => {
        // callback function to call when event triggers
        const onPageLoad = () => {
            hideWpContent("wait");
        // do something else
        };

        // Check if the page has already loaded
        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
        window.addEventListener('load', onPageLoad, false);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, []);

    useEffect(() => {
        // This useEffect specifically handles navigation on map since one-way searches do not contain search location coords
        // hence, if results exist --> use first results homeLocation data to set map canter for search
        if(dataContext.oneWayRes && dataContext.mapData && dataContext.mapData.length > 0) {
            let oneWayLat = dataContext.mapData[0].homeLocationData.coordinates.latitude;
            let oneWayLng = dataContext.mapData[0].homeLocationData.coordinates.longitude;
            if (oneWayLat && oneWayLng) {
                // adding slight offset to lat, lng to ensure green marker is not direct under a vehicle marker
                setLatlng([oneWayLat + 0.002, oneWayLng + 0.002, 1]);
            }
        } else {
            if (!dataContext.oneWayRes && latlng[2] === 1) {
                // setting lat, lng back to normal res coords + resTypeRef (0)
                setLatlng([60.167488, 24.942747, 0])}
        }
    }, [dataContext.oneWayRes, dataContext.mapData]);

    useEffect(() => {
        if(dataContext.oneWayRes && (searchParameters?.discount || storeDiscountCoupon)) {
            dataContext.changeUser({ ...dataContext.user, couponCode: '' });
            dispatch({ type: "SET_DISCOUNT_COUPON", payload: null });
            sessionStorage.removeItem("coupon");
            sessionStorage.setItem('urlCodeValid', 'removed');
            changeSearchParameters({...dataContext.searchParameters, discount: null});
        }
    }, [dataContext.oneWayRes])

    const SwitchComponents = () => {
        switch (route) {
            case "/":
                return <SearchResultsContainer setIsSearching={(v: string) => {
                }} setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                        changeRoute("/login")
                    } else {
                        changeRoute("/makereservation")
                    }
                }}/>
            case "/login":
                const LoginModal = () => {
                    return (
                        <Modal isOpen={!!(showLogin && API_URL)} style={customStyles} contentLabel='Login'>
                            <LoginContainer
                                setRedirect={(v: string) => {
                                    setShowLogin(false)
                                }}
                                setUser={dataContext.changeUser}
                                clearUserSelections={dataContext.clearSelections}
                                setIsLoggedIn={dataContext.changeLoggedIn}
                                sendGaEvent={sendGaEvent}
                                closeModal={() => setShowLogin(false)}
                                appContext={dataContext.appContext ?? ''}
                                rootUrl={dataContext.rootUrl ?? ''}
                            />
                        </Modal>
                    );
                }
                return <LoginModal />;

            case "/makereservation":
                return <MakeReservation setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                    }
                }}/>
            case "/myreservations":
                return <MakeReservation setRedirect={() => {
                }}/>
            default:
                return <SearchResultsContainer
                    setIsSearching={(v: string) => {
                }} setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                        changeRoute("/login")
                    } else {
                        changeRoute("/makereservation")
                    }
                }}/>
        }
    }

    const closeloginBtn = document.querySelector('.modal-close');
    if(closeloginBtn){
        closeloginBtn.addEventListener('click', () => {
            setShowLogin(false);
        });
    }

    useEffect(() => {
        SwitchComponents();

        if(route === "/" && dataContext.reservationCreated) {
            dataContext.clearSelections();
            dispatch({ type: "CLEAR_SELECTIONS", payload: null });
        }
    }, [route, page, dataContext.reservationCreated]);

    const handleMapBtn = () => {
        if(dataContext.mobileDevice && !dataContext.mapCanInit) {
            // if mobile, allow map to initialize only when user opens map
            // only does this once
            dataContext.changeMapCanInit();
        }
        setShowFullScreenMap(true)
        if(showFullScreenMap){
            setShowFullScreenMap(false)
        }
    }

    useEffect(() => {
        if(route === '/'){
            dataContext.changePage(0)
        }
        // close map on mobile when only one vehicle is selected
        if(dataContext.mapData?.length === 1 && route === "/makereservation" && window.innerWidth <= 768){
            setShowFullScreenMap(false)
        }
    }, [dataContext.mapData, route])


    return <div className={'flex-row mx-0 d-flex h-100 justify-content-between mainContainer'}>
        {dataContext.mapEnabled && dataContext.searchParameters?.location ? <button className={`btn btn-secondary mapBtn`}
                                            onClick={handleMapBtn}> { showFullScreenMap ? translateService.translate('briefingPhase.closeMapButton') :
            translateService.translate('briefingPhase.openMapButton') } </button> : null}
        <div className={`px-0 overflow-auto justify-content-center pageContainer ${showFullScreenMap ? 'd-none' : 'mw-100'}`}>
            <ResponseModal
                response={responseModal}
                // tslint:disable-next-line: jsx-no-lambda
                closeFunc={() => {
                    dispatch({type: "SET_RESPONSE_MODAL", payload: undefined});
                }}
            />
            <BusyModal message={apiMessage}/>
            <Modal isOpen={!!(showLogin && API_URL)} style={customStyles} contentLabel='Login'>
                <LoginContainer
                    setRedirect={(v: string) => {
                        setShowLogin(false)
                    }}
                    setUser={dataContext.changeUser}
                    clearUserSelections={dataContext.clearSelections}
                    setIsLoggedIn={dataContext.changeLoggedIn}
                    sendGaEvent={sendGaEvent}
                    closeModal={() => setShowLogin(false)}
                    appContext={dataContext.appContext ?? ''}
                    rootUrl={dataContext.rootUrl ?? ''}
                />
            </Modal>
            {SwitchComponents()}
            <div className={'versionNumberDiv'}>
                <p className={'versionNumber px-2'}>©{copyrightYear} 24Rental Network - v{version}</p>
            </div>

            <Dialog className='extension-modal' open={!!dataContext.twentyModal}>
                <Card className={`card-body py-4`}>
                    <div className="text-center py-2">
                        <h5><Translate content={'vehicleSearch.twenty'} /></h5>
                    </div>
                    <button className={'btn mt-2 align-self-center'} style={{background: '#0BB395', width: '100px'}} onClick={() => {dataContext.changeTwentyModal(false)}}>
                        <span>OK</span>
                    </button>
                </Card>
            </Dialog>
        </div>
        {
            dataContext.mapEnabled &&
            <div className={showFullScreenMap ? 'mapContainer d-all' : 'mapContainer'}>
                <GoogleMap mapData={dataContext.mapData ?? []}
                           width={`${!showFullScreenMap ? '100%' : '100vw'}`}
                           lat={!dataContext.oneWayRes ? dataContext.searchParameters?.lat || latlng[0] : latlng[0]}
                           lng={!dataContext.oneWayRes ?dataContext.searchParameters?.lon || latlng[1] : latlng[1]}
                           zoom={12} />
            </div>
        }
    </div>
}

export default App
